// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3mDnk","title":"ClientReferral_title__1QxVT","itemText":"ClientReferral_itemText__3BTHF"};